import React from "react";
import { Grid, Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Question from "../../components/Question";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";
import ContinueButton from "../../components/ContinueButton";
import { setReturning as updateReturning } from '../../redux/userSlice';

export default function ConcernChoice() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { portal = false } = location.state || {};

    const concernOptions = {
        "Existing Concern": "/patient-cases",
        "New Concern": "/concern"
    };
    const handleBack = () => {
        if (portal) {
            navigate('/returning-patient', { state: { portal: portal } });
        } else {
            navigate('/returning-patient');
        }
    };

    return (
        <Question
            onBack={handleBack}
            title="Are you seeking care for an existing concern or a new one?"
            subtitle="This will help us guide you to the right path."
            input={
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            width: { xs: "100%", sm: "80%", md: "70%" },
                            maxWidth: 600,
                            justifyContent: "center",
                        }}
                    >
                        {Object.entries(concernOptions).map(([label, path]) => (
                            <Grid
                                item
                                xs={12}
                                key={label}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <ContinueButton
                                    sx={{ width: "100%", maxWidth: "500px" }}
                                    onClick={() => {
                                        if (path === "/patient-cases") {
                                            dispatch(updateReturning(true));
                                            setPageAndDeferNavigate(dispatch, "/patient-cases", () =>
                                                navigate('/patient-cases', { state: { portal } })
                                            );
                                        } else {
                                            setPageAndDeferNavigate(dispatch, "/concern", () =>
                                                navigate("/concern", { state: { portal: portal } })
                                            );
                                        }
                                    }}
                                    title={label}
                                    selected={true}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            }
        />
    );
}
